import React from 'react';
import { Card } from './ui/Card';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'We generate an extra $100,000 every month just through follow-ups.',
  author: 'Luis Warkuss',
  role: 'CEO',
  initial: 'L',
  color: 'bg-blue-500'
}, {
  quote: 'We grew from $250,000 to over $450,000 in monthly revenue.',
  author: 'Henri CL',
  role: 'CEO',
  initial: 'H',
  color: 'bg-purple-500'
}, {
  quote: 'We tripled to quintupled our revenue – without massively expanding our sales team.',
  author: 'Tax Mentoring',
  role: 'Partner',
  initial: 'T',
  color: 'bg-green-500'
}];
export function ResultsSection() {
  return <section className="py-20 bg-[#0A0E27]" data-id="element-113" data-mp="lpy1sw25lx7x">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114" data-mp="lqqx90vnx0ar">
        <div className="text-center mb-16" data-id="element-115" data-mp="3kg7tlom3ckm7">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-116" data-mp="3kdbwu3lzc1zc">
            What My Clients Achieve
          </h2>
          <p className="text-[#94A3B8] max-w-2xl mx-auto" data-id="element-117" data-mp="y6u3q0pliy38">
            Results speak louder than words. Here are real numbers from
            companies I have worked with.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-118" data-mp="oh0rqyljkgyg">
          {testimonials.map((item, index) => <Card key={index} variant="hover" className="p-8 flex flex-col h-full" data-id="element-119" data-mp="jiqxqrbjzmef" data-mpi={index}>
              <Quote className="w-8 h-8 text-[#FF5722] mb-6 opacity-50" data-id="element-120" data-mp="fi6x3drru0nj" />
              <p className="text-lg text-white font-medium mb-8 flex-grow" data-id="element-121" data-mp="aghmfz8gnozz">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-[#1E293B]" data-id="element-122" data-mp="5iy68ts7d25e">
                <div className={`w-10 h-10 rounded-full ${item.color} flex items-center justify-center text-white font-bold`} data-id="element-123" data-mp="kmwsk5tktnp">
                  {item.initial}
                </div>
                <div data-id="element-124" data-mp="1uy5q1hsthq37">
                  <div className="text-white font-bold" data-id="element-125" data-mp="3pdkznmf6xxri">{item.author}</div>
                  <div className="text-xs text-[#94A3B8]" data-id="element-126" data-mp="3pc9x1pxhew1z">{item.role}</div>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}